import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { db } from '../firebase';
import { doc, setDoc, getDoc } from 'firebase/firestore';
import './Login.css';

const Login = () => {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setErro('');
    setCarregando(true);
    try {
      const resultado = await login(email, senha);
      const ref = doc(db, 'usuarios', resultado.user.uid);
      const snap = await getDoc(ref);
      if (!snap.exists()) {
        await setDoc(ref, {
          uid: resultado.user.uid,
          email,
          nome: 'Usuário',
          materias: [],
          presencas: [],
          streak: 0,
          pacote: 1,
          criadoEm: new Date().toISOString()
        });
      }
    } catch (err) {
      setErro('E-mail ou senha incorretos. Verifique e tente novamente.');
    } finally {
      setCarregando(false);
    }
  };

  const stats = [
    { icone: '🧠', num: 'Científico', label: 'Método comprovado' },
    { icone: '📊', num: 'Completo', label: 'Dashboard em tempo real' },
    { icone: '🏆', num: 'Competitivo', label: 'Ranking motivador' },
    { icone: '☁️', num: 'Na nuvem', label: 'Acesso em qualquer lugar' },
  ];

  return (
    <div className="login-page">

      {/* ─── LADO ESQUERDO ─── */}
      <div className="login-left">
        <div className="login-left-overlay" />
        <div className="login-left-content">

          {/* Brand */}
          <div className="login-brand">
            <div className="login-logo-wrapper">
              <span className="login-logo-icon">🎓</span>
            </div>
            <div>
              <h1 className="login-titulo">PRUVENX</h1>
              <p className="login-titulo-sub">APROVADO</p>
            </div>
          </div>

          {/* Headline */}
          <div className="login-headline">
            <h2>
              Pare de estudar tudo.<br />
              <span>Estude o que cai.</span>
            </h2>
            <p>
              Enquanto outros revisam 500 páginas, você estuda só o que aparece na prova.
              Método científico + Repetição espaçada + Conteúdo filtrado por concurso.
            </p>
          </div>

          {/* Stats */}
          <div className="login-stats">
            {stats.map((s, i) => (
              <div key={i} className="login-stat">
                <span className="ls-icone">{s.icone}</span>
                <span className="ls-num">{s.num}</span>
                <span className="ls-label">{s.label}</span>
              </div>
            ))}
          </div>

          {/* Features */}
          <div className="login-features">
            {[
              { icone: '✅', texto: 'Conteúdo filtrado por concurso e banca' },
              { icone: '✅', texto: 'Revisão inteligente dos seus pontos fracos' },
              { icone: '✅', texto: 'Simulados no padrão da banca' },
              { icone: '✅', texto: 'Você estuda menos e retém muito mais' },
              { icone: '✅', texto: 'Progresso salvo na nuvem em qualquer dispositivo' },
            ].map((f, i) => (
              <div key={i} className="login-feature">
                <span className="lf-icone">{f.icone}</span>
                <span className="lf-texto">{f.texto}</span>
              </div>
            ))}
          </div>

          {/* Frase de impacto */}
          <div style={{
            padding: '18px 20px',
            background: 'rgba(255,255,255,0.06)',
            borderLeft: '4px solid #facc15',
            borderRadius: '0 12px 12px 0'
          }}>
            <p style={{ color: '#facc15', fontWeight: 800, fontSize: '0.95rem', marginBottom: 6 }}>
              🏆 Método que aprova. Não que impressiona.
            </p>
            <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.82rem', lineHeight: 1.6, margin: 0 }}>
              Imagine parar para revisar o conteúdo completo e perceber que já sabe tudo que vai cair.
              Essa plataforma vai muito além de qualquer estratégia já desenvolvida.
            </p>
          </div>

          {/* Tag revisão para concursos */}
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: 8,
              padding: '10px 24px', borderRadius: 99,
              background: 'rgba(37,99,235,0.2)',
              border: '1px solid rgba(37,99,235,0.35)',
              color: '#93c5fd', fontSize: '0.85rem', fontWeight: 700
            }}>
              <span>🎯</span>
              <span>Revisão para Concursos</span>
            </div>
          </div>

          {/* Contadores */}
          <div style={{ display: 'flex', gap: 12 }}>
            {[
              { num: '730+', label: 'Flashcards', icone: '📚' },
              { num: '200+', label: 'Questões', icone: '🎯' },
            ].map((s, i) => (
              <div key={i} style={{
                flex: 1, display: 'flex', alignItems: 'center', gap: 10,
                background: 'rgba(255,255,255,0.06)',
                border: '1px solid rgba(255,255,255,0.1)',
                padding: '12px 16px', borderRadius: 12
              }}>
                <span style={{ fontSize: '1.3rem' }}>{s.icone}</span>
                <div>
                  <div style={{ fontWeight: 900, fontSize: '1.1rem', color: 'white' }}>{s.num}</div>
                  <div style={{ fontSize: '0.7rem', color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase', letterSpacing: 1 }}>{s.label}</div>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>

      {/* ─── LADO DIREITO ─── */}
      <div className="login-right">
        <div className="login-right-bg" />
        <div className="login-box">
          <div className="login-box-header">
            <div className="login-box-icon">🔐</div>
            <h2 className="login-box-titulo">Acesse sua conta</h2>
            <p className="login-box-sub">Entre com seu e-mail e senha para continuar</p>
          </div>

          <form onSubmit={handleLogin} className="login-form">
            {erro && <div className="alert alert-danger">{erro}</div>}
            <div className="input-group">
              <label className="input-label">E-mail</label>
              <div className="input-wrapper">
                <span className="input-icon">✉️</span>
                <input
                  className="input input-with-icon"
                  type="email"
                  placeholder="seu@email.com"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  autoComplete="username"
                  required
                />
              </div>
            </div>
            <div className="input-group">
              <label className="input-label">Senha</label>
              <div className="input-wrapper">
                <span className="input-icon">🔒</span>
                <input
                  className="input input-with-icon"
                  type="password"
                  placeholder="••••••••"
                  value={senha}
                  onChange={e => setSenha(e.target.value)}
                  autoComplete="current-password"
                  required
                />
              </div>
            </div>
            <button
              type="submit"
              className="btn btn-primary btn-lg login-btn-submit"
              disabled={carregando}
            >
              {carregando ? '⏳ Entrando...' : '🚀 Entrar na plataforma'}
            </button>
          </form>

          <div className="login-box-footer">
            <div className="login-seguranca">
              <span>🔒</span>
              <span>Acesso seguro — dados criptografados</span>
            </div>
            <div className="login-powered">
              Powered by <strong>PRUVENX</strong> © {new Date().getFullYear()}
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Login;